import React from 'react';

import { IoIosSearch } from 'react-icons/io'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { Col, Row, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';


import { search } from 'api/actions';

import {
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_FAILURE
} from 'constants/ActionTypes';

import FileIcon from '../FileIcon';

import './index.css';

const NUM_OF_SEARCH_RESULT = 6;
const REQUESTER_ID = 'SEARCH_INPUT';
let TIMEOUT = null;
let SEARCH_TIMEOUT = null;


function SearchResults(props) {
  console.log('SEARCH RESULTS ARE', props)
  return (
    <div
      className={'search-input-results'}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {props.data.map(object => {
        const path = object.is_dir ? `/dashboard?prefix=${object.path}` : `/preview?id=${object.id}`;

        return (
          <Link to={path} className={'search-input-results-title'}>
            <p key={object.id}>
              <FileIcon {...object}/>
              {object.name}
            </p>
          </Link>
        )
      })
       }
    </div>
  )
}

function GlobalSearch(props) {
  return (
    <div className='search-input-all'>
      <Link
        to={`/search?q=${props.value}`}
      >
        Search for {props.value}
      </Link>
    </div>
  )
}

class SearchInput extends React.Component {
  state = {
    active: false,
    data: [],
    loading: false,
    value: ''
  };

  defaultProps = {
    objects: {}
  }

  componentWillReceiveProps(nextProps) {
    // TODO: Remove this code and do something better.
    // Handle the case where starred items and search bar are using the same event
    if (nextProps.requester !== REQUESTER_ID) {
      return this.setState({
        loading: false
      });
    }

    switch (nextProps.type) {
      case SEARCH:
        this.setState({ loading: true });
        break;
      case SEARCH_SUCCESS:
        const newState = { loading: false };
        if (this.state.active) {
          const keys = Object.keys(nextProps.objects);
          newState.data = keys.map(key => nextProps.objects[key]);
        }
        this.setState(newState);
        break;
      case SEARCH_FAILURE:
        this.setState({ loading: false });
        break;
    }
  }

  componentWillUnmount() {
    clearTimeout(TIMEOUT);
  }

  onTyping = (e) => {
    const value = e.target.value;

    this.setState({ value })

    if (value) {
      clearTimeout(SEARCH_TIMEOUT);

      ((value) => {
        SEARCH_TIMEOUT = setTimeout(() => {
          this.props.search({ q: value, size: NUM_OF_SEARCH_RESULT }, REQUESTER_ID);
        }, 300)
      })(value)
    }
  };

  onFocus = () => {
    this.setState({ active: true });
  };

  onBlur = () => {
    // This allows any link clicked to perform its action before blurring.
    // Like if a user clicks a folder or file link, this will blur before the link
    // is navigated to.
    TIMEOUT = setTimeout(() => {
      this.setState({ active: false });
      clearTimeout(TIMEOUT);
    }, 100)
  };

  onKeyPress = (e) => {
    if (!e) e = window.event;
    const keyCode = e.keyCode || e.which;
    if (keyCode == '13'){
      const value = this.input.value;

      if (value) window.location = `/search?q=${value}`

      return false;
    }
  }

  render() {
    const dataPresent = this.state.data.length > 0;

    const { active, loading, value } = this.state;

    return (
      <div style={{ height: 50, marginTop: 15, position: 'relative', width: '100%' }}>
        <Row
          className={`search-input-container${!this.state.active ? ' search-input-container-inactive' : ' search-input-container-active'} `}
        >
          <Col md={12} className={'search-input-main'}>
            <div
              style={{
                width: 30,
                height: '100%',
                backgroundColor: 'transparent',
                color: '#C1C7CD',
                fontSize: 20
              }}
            >
              <IoIosSearch />
            </div>
            <input
              ref={ref => this.input = ref}
              className={'search-input'}
              type="text"
              placeholder={'Search MiDrive'}
              onChange={this.onTyping}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onKeyPress={this.onKeyPress}
            />
            {loading && <Spinner size={'sm'}/>}
          </Col>
          { value && active && <hr /> }
          { value && active && <GlobalSearch value={value} /> }
          { dataPresent && active && <hr /> }
          { active && <SearchResults data={this.state.data} /> }
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  objects: state.entities && state.entities.objects ? state.entities.objects : {},
  type: state.type,
  requester: state.requester
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ search }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(SearchInput);